module.exports = __webpack_public_path__ + "static/img/3.e4c2ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/3.png
// module id = WDxf
// module chunks = 1